module.exports = __webpack_public_path__ + "static/img/3.8b348b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/3.jpg
// module id = +oo4
// module chunks = 0